module.exports = __webpack_public_path__ + "img/11.a99f52fa.png";